import $pageConfig from "webutils/services/page-config";

export default class AutoQueryTextFilter {
  constructor(config, $aq) {
    const g = this;
    const fieldName = config.fieldName || config.text || config.toString();
    Object.assign(g, config);
    // console.warn("AutoQueryTextFilter", { config, $aq, g });
    g.type = "text";
    g.query = $aq;
    g.bus = $aq.bus;
    g.tagKind = g.fieldName = fieldName;
    g.aqField = fieldName + (config.operation || "");
    g.title = config.title || fieldName;
  }

  search(value) {
    const g = this;
    // console.warn("AutoQueryTextFilter.search", value, { value, g });
    if (g.clearRefinements) {
      g.query.clearRefinements(false);
      g.query.clearNavs(false);
    }
    g.query.criteria[g.aqField] = value;

    g.query.load(true);
    g.query.scrollTop && $pageConfig && $pageConfig.goTop();
  }

  toggle(value) {
    const g = this;
    if (g.query.criteria[g.aqField] === value) g.clear(true);
    else g.search(value);
  }

  readQueryString(fieldName, value) {
    const g = this;
    if (
      value &&
      value !== "null" &&
      (fieldName.toLowerCase() == g.aqField.toLowerCase() ||
        fieldName.toLowerCase() == g.fieldName.toLowerCase())
    ) {
      g.query.criteria[g.aqField] = value;
    }
  }

  writeQueryString(params) {
    const g = this;
    if (g.query.criteria[g.aqField])
      params[g.aqField] = g.query.criteria[g.aqField];
  }

  clear(load) {
    const g = this;
    for (const fieldName in g.query.criteria) {
      if (
        fieldName.toLowerCase() == g.aqField.toLowerCase() ||
        fieldName.toLowerCase() == g.fieldName.toLowerCase()
      ) {
        delete g.query.criteria[fieldName];
      }
    }
    load && g.query.load(true);
  }
  clearOld() {
    const g = this;
    delete g.query.criteria[g.aqField];
  }

  getRefinements() {
    const g = this;
    let results = [];
    if (g.query.criteria[g.aqField])
      results.push({
        label:
          ((g.title || "").trim().length > 0 ? g.title : g.aqField) +
          ": " +
          g.query.criteria[g.aqField],
        remove: g.clear.bind(g, true),
      });
    return results;
  }

  getParams() {
    const g = this;
    return g.query.criteria[g.aqField] ? [g.query.criteria[g.aqField]] : [];
  }
}
